// Because of the way this file is set up, this works the same
// as a document.ready statement.
// Add your code, either within the misc: section, or create your own function
// if you create your own, make sure to add a line at the bottom to run that code
// ie: Engine.ui.misc();
$(function () {
  "use strict";
  var Engine = {
    ui: {
      misc: function () {
        $('body').click(function(e){
          var container = $(".cart-side-panel");
          if (!container.is(e.target) && container.has(e.target).length === 0) 
          {
            $('body').removeClass("CartOpen ");
          }
        });
        $('#shoppingcart, .menu-toggle, #blog-sidebar').click(function(e){
          var scontainer = $(".header_search_bar"); 
          if(!scontainer.is(e.target) && scontainer.has(e.target).length === 0) { 
            scontainer.hide();
            $(".search_media_icon").removeClass('active');
          } 
        });
        $('.nav_bar_menu ul li.megamenu a.site-nav__link--button, .site-nav__dropdown').hover(function(){
          $(this).parents('.nav_bar_menu ul li.megamenu').find('.site-nav__dropdown').addClass('open_submenu');
          $(this).parents('li').addClass('active_link');
        },function(){
          $(this).parents('.nav_bar_menu ul li.megamenu').find('.site-nav__dropdown').removeClass('open_submenu');
          $(this).parents('li').removeClass('active_link');
        });
        $('.plus').on('click', function() {
          var $qty = $(this).parents('.pro_description_pro').find("ul.QuantityBox li .QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (!isNaN(currentVal)) {
            $qty.val(currentVal + 1);
          }
        });
        $('.minus').on('click', function() {
          var $qty = $(this).parents('.pro_description_pro').find("ul.QuantityBox li .QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (!isNaN(currentVal) && currentVal > 0) {
            $qty.val(currentVal - 1);
          }
        });
        $('.my_variant').click(function(){
          if($(".pro_size").is(":visible")){
            $(this).parents('.swatch_title_btn').find('.pro_size').css({"display":"none", "opacity":"0"});
          }
          else{
            $(this).parents('.swatch_title_btn').find('.pro_size').css({"display":"block", "opacity":"1"});
          }
        });
        $(document).on('click', '.select_your_style li', function() {
          $('.select_your_style .mw_options_list').hide();
          var input_val = $("input[name='properties[Select Your Style]']:checked").val();
          if( input_val == 'Ring'){
            $('.metal_here select').change(function(){
              $('.silver_pendant_design').css('display','none');
              var selected = $('.metal_here select option:selected').val();
              if(selected == 'Silver'){
                $('.silver_design').css('display', 'block');
              }
              else if(selected == 'Panchdhatu (Silver base)'){
                $('.panchdhatu_rign_design').css('display', 'block');
              }
              else if(selected == '22kt Yellow Gold'){
                $('.22kt_gold_ring_design').css('display', 'block');
              }
              else if(selected == 'Copper'){
                $('.copper_design').css('display', 'block');
              }
              else if(selected == '18kt Yellow Gold'){
                $('.18kt_yellow_gold_design').css('display', 'block');
              }
              else if(selected == '18kt White Gold'){
                $('.18kt_gold_ring_design').css('display', 'block');
              }
            }); 
            $('.select_your_style .mw_options_list').hide();
            $('.fixed_ring_style').show();
            $('.fixed_gemstone_style').hide();
            $('.fixed_pendant_style').hide();
          }
          else if( input_val == 'Pendant'){
            $('.metal_here select').change(function(){
              $('.option_designs').css('display', 'none');
              var selected = $('.metal_here select option:selected').val();
              if(selected == 'Silver'){
                $('.pendant_silver').css('display', 'block');
              }
              else if(selected == 'Panchdhatu (Silver base)'){
                $('.panchdhatu_pendant').css('display', 'block');
              }
              else if(selected == '22kt Yellow Gold'){
                $('.22kt_yellow_pendant').css('display', 'block');
              }
              else if(selected == 'Copper'){
                $('.copper_pendant').css('display', 'block');
              }
              else if(selected == '18kt Yellow Gold'){
                $('.18kt_yellow_pendant').css('display', 'block');
              }
              else if(selected == '18kt White Gold'){
                $('.gold_pendant_design').css('display', 'block');
              }
            });
            $('.select_your_style .mw_options_list').hide();
            $('.fixed_pendant_style').show();
            $('.fixed_ring_style').hide();
            $('.fixed_gemstone_style').hide();
          }
          else if( input_val == 'Loose Gemstone'){
            $('.select_your_style .mw_options_list').hide();
            $('.fixed_gemstone_style').show().removeClass('hide');
            $('.fixed_pendant_style').hide();
            $('.fixed_ring_style').hide();
          }
        });
        $(document).on('click', '.ring_metal_type .mw-option-description', function(){
          $('.select_your_style .mw_options_list').show();
          $('.ring_metal_type').hide();
        });
        $(document).on('click', '.qh-smart-bar__block .action-block a', function(){
          $('.qh-smart-bar__block').addClass('hide');
          $('body').css('padding-top','0');
        });
        $(".search_media_icon").on('click',function () {
          if($('.header_search_bar').is(":visible")){
            $('.header_search_bar').hide();
          }
          else{
            $('.header_search_bar').show();
            $('.header_search_bar input').focus();
          } 
          $(this).toggleClass('active');
          return false;
        });
        $(document).on('click', '.edit-options', function(){
          checkContainer();
        });
        $(document).on('change','.certification select', function(){
          getDate();
        });
        $(document).on('click', '.ring_size_selection .mw-option-description', function(){
			$('#ring_size_chart').show().css('background-color','rgba(0,0,0,0.5)');
        });
        $(document).on('click', '.close_chart', function(){
        	$('#ring_size_chart').hide();
        });
      },
    },
    utils: {
      sliders: function() {
        $('.inner_collectio_grid').slick({
          centerMode: false,
          slidesToShow: 4,
          slidesToScroll: 4,
          slide: "li",
          dots: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 375,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
        });
      },
    },
  };
  Engine.ui.misc();
  Engine.utils.sliders();
});
$('textarea').each(function () {
  $(this).val($(this).val().trim());
});

$(".redirect_div_arrow").on('click', function(event) {   
  if (this.hash !== "") {
    var hash = this.hash;
    var heightMin = $('header').innerHeight();
    if ($(window).width() <= 991){
      $('html, body').animate({
        scrollTop: $(hash).offset().top - heightMin - 30
      }, 800, function(){});
    }
    else if ($(window).width() >= 992){
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 10
      }, 800, function(){});
    }

  }
  return false;
});

$(".filter_tag_group li a").on('click', function(event) {  
  if (this.hash !== "") {
    var hash = this.hash;
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 300, function(){
      window.location.hash = hash;
    });
  }
});
function responsivecolumn(){
  if ($(window).width() <= 991){
    $(".site-nav--has-dropdown.megamenu > a .icon_down_nav, .site-nav__link--button").click(function (e) {
      $(this).parents('.site-nav--has-dropdown').find('.site-nav__dropdown').slideToggle('fast');
      console.log(this);
      $(this).parents('.site-nav--has-dropdown').toggleClass('active');
      e.stopImmediatePropagation();
    });
  }
  else if ($(window).width() >= 992){
    $(".site-nav--has-dropdown.megamenu > a .icon_down_nav, .site-nav__link--button").stop();
    var headerHeight = $('header').innerHeight();
    var footerHeight = $('footer').innerHeight();
    var windowHeight = $(window).innerHeight();
    var contentHeight = headerHeight + footerHeight;
    var totalHeight = windowHeight - contentHeight;
    $('.inner_conteiner_tq').css('min-height', totalHeight - 35 + 'px');
  }
};
function getDate(date, days){
  var targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + 3);
  var dd = targetDate.getDate();
  var mm = targetDate.getMonth() + 1; 
  var yyyy = targetDate.getFullYear();
  var dateString = dd + "/" + mm + "/" + yyyy;
  $(".date_time").text(dateString);
  if ($('.right_side_pro_desc .mw-options-container').is(':visible')){
    var str = $('.certification select').val(); 
    var matches = str.match(/(\d+)/); 
    var inte_date = parseInt(matches[0]);
    targetDate.setDate(targetDate.getDate() + inte_date);
    var dd = targetDate.getDate();
    var mm = targetDate.getMonth() + 1; 
    var yyyy = targetDate.getFullYear();
    var dateString = dd + "/" + mm + "/" + yyyy;
    $(".date_time").text(dateString);
  }
}
function remove_item(id) {
  document.getElementById('updates_'+id).value = 0;
  document.getElementById('cartform').submit();
}
$(document).ready(function(){
  responsivecolumn();
  $('.name_of_child_menu li a').click(function(){
    $(this).parent().siblings().children().removeClass('active');
    $(this).parents('.firstli').toggleClass('active');
    var menu_data = $(this).data('value');
    $('.right_tabbed_menu .inner_right_menu_div').each(function(element){
      var tab_data = $(this).data('id');
      if(menu_data == tab_data){
        $(this).show().siblings().hide();
      }
    });
  });  
  $('ul.childul li.firstli a').on( "click", function(e){ 
    var id = $(this).data('value');
    $(this).parent().next('.right_tabbed_menu').slideToggle('slow');
  });
});
$(window).resize(function(){
  responsivecolumn();
  getDate();
});
$(window).load(function(){
  $(".input_field_group input").each(function(){
    var form_val = $(this).attr('value');
    var form_reg = $(this).attr('placeholder');
    if($(this).val().length || form_reg){
      $(this).addClass("has-content");
    }
    else{
      $(this).removeClass("has-content");
      $(".input_field_group input").focusout(function(){
        if($(this).val().length || form_reg.size) {
          $(this).addClass("has-content");
        }
        else{
          $(this).removeClass("has-content");
        }
      });
    }
  });
  responsivecolumn();
  getDate();
});

$(window).scroll(function(){
  var sticky = $('header'),
      scroll = $(window).scrollTop();
  if (scroll >= 200) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});
$('img').hover(
  function () {
    $(this).data('title',$(this).attr('title')).removeAttr('title');
  }, 
  function () {
    $(this).attr('title',$(this).data('title'));
  }
);


/*------ filter_drawer ---------*/
var $filterSidebar = $('.side_filter_panel');
var $toggleButton = $('#open-filters');
var $overlay = $('body').find('.widgets-filter-overlay');
function _open() {
  $filterSidebar.addClass('open_bar');
  if (! $overlay.length) {
    $('body').append('<div class="widgets-filter-overlay"></div>');
  }
  $('body').addClass('filter_open');
}

function _close() {
  $filterSidebar.removeClass('open_bar');
  $(document).find('.widgets-filter-overlay').remove();
  $('body').removeClass('filter_open');
}

$toggleButton.on('click', function() {
  if (! $filterSidebar.hasClass('open_bar')) {
    _open();
  } else {
    _close();
  }
});
$('.btn_close_filter').click(function(){
  _close();
});
/*------ menu_drawer ---------*/
var $menuslider = $('.inner_outer');
var $menuTogle = $('.mobile_nav .menu-toggle');
function menu_open() {
  $menuslider.addClass('menu_open');
  if (! $overlay.length) {
    $('body').append('<div class="widgets-filter-overlay"></div>');
  }
  $('body').addClass('open_menu');
}
function menu_close() {
  $menuslider.removeClass('menu_open');
  $(document).find('.widgets-filter-overlay').remove();
  $('body').removeClass('open_menu');
}
$menuTogle.on('click', function() {
  if (! $menuslider.hasClass('menu_open')) {
    menu_open();
  } else {
    menu_close();
  }
});
$('.navbar-toggler_close').click(function(){
  menu_close();
});

/*------ cart_drawer ---------*/
var $cartslider = $('.cart-side-panel');
var $carttoggle = $('#shoppingcart');
function cart_open() {
  $cartslider.addClass('cart_open');
  if (! $overlay.length) {
    $('body').append('<div class="widgets-filter-overlay"></div>');
  }
  $('body').addClass('cartOpen');
}
function cart_close() {
  $cartslider.removeClass('cart_open');
  $(document).find('.widgets-filter-overlay').remove();
  $('body').removeClass('cartOpen');
}
$carttoggle.on('click', function() {
  if (! $cartslider.hasClass('cart_open')) {
    cart_open();
  } else {
    cart_close();
  }
});
$('.cart-close').click(function(){
  cart_close();
});

$('body').on('click', '.widgets-filter-overlay', function() {
  cart_close();
  _close();
  menu_close();
});

/*------ blog_drawer ---------*/
var $blogslider = $('.cart-side-panel');
var $blogtoggle = $('#blog-sidebar');
function blog_open() {
  $blogslider.addClass('blog_open');
  if (! $overlay.length) {
    $('body').append('<div class="widgets-filter-overlay"></div>');
  }
  $('body').addClass('open_sidebar');
}
function blog_close() {
  $blogslider.removeClass('blog_open');
  $(document).find('.widgets-filter-overlay').remove();
  $('body').removeClass('open_sidebar');
}
$blogtoggle.on('click', function() {
  if (! $blogslider.hasClass('blog_open')) {
    blog_open();
  } else {
    blog_close();
  }
});
$('.btn_close_blog').click(function(){
  blog_close();
});

$('body').on('click', '.widgets-filter-overlay', function() {
  cart_close();
  _close();
  menu_close();
  blog_close();
});
function checkContainer () {
  if($('.mw-option').is(':visible')){
    if (!$('.ring_metal_type').is(':visible')){
      $('.select_your_style .mw_options_list').show();
    }
    var opt_val = $('.ring_metal_type input:checked').val();
    if (opt_val == 'Ring'){
      $('.silver_pendant_design').hide();
    }
    else if (opt_val == 'Pendant'){
      $('.option_designs').hide();
    }
  } else {
    setTimeout(checkContainer, 50);
  }
}

 


